import { useMutation } from '@tanstack/react-query'
import { apiClient } from '@/lib/api/client'

interface CodeAnalysisRequest {
  project_id: number
  code_files: Array<{ path: string; content: string; language: string }>
  language: string
  test_framework: string
  generation_type?: string
  include_edge_cases?: boolean
  include_negative_tests?: boolean
  max_test_cases?: number
}

interface RequirementTestsRequest {
  project_id: number
  reqspec_id: number
  requirement_ids: number[]
  test_types: string[]
  target_framework: string
  generate_code?: boolean
  auto_link_coverage?: boolean
  suite_name_prefix?: string
}

interface SecurityScanRequest {
  project_id: number
  code_files: Array<{ path: string; content: string; language: string }>
  scan_type?: string
}

interface DRDTestGenerationRequest {
  project_id: number
  drd_id: number
  generation_type?: string
  test_framework?: string
  max_test_cases?: number
}

interface JobSubmissionResponse {
  status: string
  message_id: string
  message: string
}

export const useSubmitCodeAnalysis = () => {
  return useMutation({
    mutationFn: async (request: CodeAnalysisRequest) => {
      const { data } = await apiClient.post<JobSubmissionResponse>(
        '/api/async/code-analysis',
        request
      )
      return data
    },
  })
}

export const useSubmitRequirementTests = () => {
  return useMutation({
    mutationFn: async (request: RequirementTestsRequest) => {
      const { data } = await apiClient.post<JobSubmissionResponse>(
        '/api/async/requirement-tests',
        request
      )
      return data
    },
  })
}

export const useSubmitSecurityScan = () => {
  return useMutation({
    mutationFn: async (request: SecurityScanRequest) => {
      const { data } = await apiClient.post<JobSubmissionResponse>(
        '/api/async/security-scan',
        request
      )
      return data
    },
  })
}

export const useSubmitDRDTestGeneration = () => {
  return useMutation({
    mutationFn: async (request: DRDTestGenerationRequest) => {
      const { data } = await apiClient.post<JobSubmissionResponse>(
        '/api/async/drd-test-generation',
        request
      )
      return data
    },
  })
}
